/**
 * 版本检查工具：生产环境检查更新，开发环境完全禁用
 * 解决：开发环境无限刷新、打包后自动提示更新
 */

// 环境判断
const isDev = process.env.NODE_ENV === 'development';

// 记录当前版本
let lastLocalVersion = '';

/**
 * 获取线上最新版本号
 */
export async function getOnlineVersion() {
  if (isDev) return '';

  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-cache',
    });
    const data = await res.json();
    return data.version || '';
  } catch (err) {
    console.log('版本检查失败');
    return '';
  }
}

/**
 * 检查是否需要更新
 */
export async function checkVersionUpdate() {
  if (isDev) return false;

  const onlineVersion = await getOnlineVersion();
  if (!onlineVersion) return false;

  // 首次加载
  if (!lastLocalVersion) {
    lastLocalVersion = onlineVersion;
    return false;
  }

  // 版本不一致 → 需要更新
  if (lastLocalVersion !== onlineVersion) {
    lastLocalVersion = onlineVersion;
    return true;
  }

  return false;
}

/**
 * 强制刷新（清缓存 + 重载）
 */
export function reloadApp() {
  if (isDev) return;
  window.location.reload(true);
}